import { useEffect, useRef, useState } from 'react';

import { getParams } from './helpers';

const usePageVisibility = () => {
  const [isVisible, setIsVisible] = useState(true);

  const visibilityParams = useRef<string[]>([] as string[]);

  const [hidden, visibilityChange] = visibilityParams.current;

  useEffect(() => {
    const params = getParams();
    visibilityParams.current = [...params];
  }, []);

  useEffect(() => {
    if (!visibilityChange) return;

    const onVisibilityChange = () => setIsVisible(!document.hidden);

    document.addEventListener(visibilityChange, onVisibilityChange, false);

    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange);
    };
  }, [hidden, visibilityChange]);

  return isVisible;
};

export default usePageVisibility;
